import React from 'react'
import { DataTool, type DataToolProps } from '@ztechapps/webui.data-tools'
import { useUnitOfMeasureContext } from './Context'
import { unitOfMeasureListFieldConfig } from './constants'
import { AddNew } from '../unit-of-measure-add/AddNew'
import { NullComponent } from '@ztechapps/webui.util'

export const UnitOfMeasureDataTool = (props: DataToolProps) => {
  const { unitOfMeasureList, onRefresh, filterCategory } = useUnitOfMeasureContext()

  return (
    <DataTool
      filterCategory={filterCategory}
      fieldsConfig={unitOfMeasureListFieldConfig}
      onRefresh={onRefresh}
      searchPlaceHolder="Search units of measure"
      components={{ other: AddNew, sort: NullComponent }}
      {...unitOfMeasureList}
      {...props}
    />
  )
}
